define.alias("shared/helpers/linkify-html", "calendar/helpers/linkify-html");